import { useQuery } from '@tanstack/react-query';
import { ICompanyFilter } from '../../aida/viewModels/companyfilter';
import { ILeadSearchView } from '../../aida/viewModels/leads/interfaces';
import { ImpersonationBroker, IOperationResultNoValue } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/filter/byCompany';

export function useLeadFilterByCompanyQuery({
	filter,
	enabled,
	meta,
	swallowHttpErrors = false,
	refetchOnWindowFocus,
}: {
	filter: ICompanyFilter;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
	swallowHttpErrors?: boolean;
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, filter],
		queryFn: async () => {
			try {
				const data = await userSession.webServiceHelper.callAsync<ILeadSearchView[]>(
					ImpersonationBroker.composeApiUrl({ urlPath: `lead/filter/byCompany` }),
					'POST',
					filter
				);
				return data;
			} catch (error) {
				if (swallowHttpErrors && (error as IOperationResultNoValue)?.systemCode >= 400) {
					return [];
				}
				throw error;
			}
		},
		enabled,
		meta,
		refetchOnWindowFocus,
		retry: (_, error) => {
			return !((error as IOperationResultNoValue)?.systemCode >= 400); // Only retry on network errors, not on 400+ HTTP errors.
		},
	});
}
